export const TheTop1ClubFree = '1578859558';
export const threeStepstoProfit = '1578861066';
export const WinningPicksAnnual = '1578861151';
export const WinningPicksMonthly = '1578861204';
export const LiveOptionsSeminar = '1578861223';
export const WinningPickseBook = '1607724476';
export const TheTop1Club = '1651365143';
export const ToolsFull = '1651597226';
export const ToolsNOC = '1651597378';
export const tools3Steps = '1688674410';


export const fullAccessLevels = [
  ToolsFull,
  WinningPicksMonthly,
  WinningPicksAnnual,
  tools3Steps,
];
export const halfAccessLevels = [
  threeStepstoProfit,
  TheTop1Club,
  ToolsNOC,
  
];



// WEBPACK FOOTER //
// ./src/accessLevels.js